export default __webpack_public_path__ + "static/media/homeImage.9b9e480a.png";